import GetAppSettings from "../api/GetAppSettings";
import GetEntityInfo from "../api/GetEntityInfo";

import formatAppSettings from "../utils/formatAppSettings/formatAppSettings";

const store = {
    namespaced: true,

    state: {
        settings: {},

        data: {},

        lastDataForm: undefined,

        ticket: undefined,

        foreign_payment: false,

        fetching: true,
        error: false,
    },

    mutations: {
        SET_SETTINGS(state, payload) {
            state.settings = payload;
        },

        SET_TICKET(state, payload) {
            state.ticket = payload;
        },

        RESET_TICKET(state) {
            state.ticket = undefined;
        },

        SET_DATA(state, payload) {
            state.fetching = false;
            state.data = payload;
        },

        SET_FETCHING(state) {
            state.fetching = true;
        },

        SET_ERROR(state) {
            state.error = true;
            state.fetching = false;
        },

        SET_COMPLETE(state) {
            state.fetching = false;
        },

        SET_FOREIGN_PAYMENT(state, payload)  {
            state.foreign_payment = payload;
        },

        SET_PRICE(state, payload) {
            state.data.ticket_price_online = payload;
        },

        SET_PRICE_FOREIGN(state, payload) {
            state.data.ticket_price_online_foreign = payload;
        },

        SET_LAST_DATA_FORM(state, payload) {
            state.lastDataForm = payload;
        },
    },

    actions: {
        async fetchData({ commit }, { type, id }) {
            commit("SET_FETCHING");

            let settings;
            let info;

            if (type !== "order") {
                try {
                    const result = await Promise.all([await GetAppSettings(type, id), await GetEntityInfo(type, id)]);

                    settings = result[0];
                    info = result[1];

                    if (info.paid && info.paid == 1) {
                        commit("SET_ERROR");
                        info = {}
                        return false;
                    }
                } catch (error) {
                    commit("SET_ERROR");

                    throw error;
                }

                commit("SET_SETTINGS", formatAppSettings(settings, type));
                commit("SET_DATA", { ...info, ...settings });
                console.log(type, info, settings);
            } else {
                try {
                    info = await GetEntityInfo(type, id);
                    settings = [{paymentMethodDefault: info.paymentMethodDefault}, ...info.operators];
                    info.multiple_items = info.items.length > 1;

                    if (!info.items.length) {
                        commit("SET_ERROR");
                        info = {}
                        return false;
                    }
                    
                    if (info.paid) {
                        commit("SET_ERROR");
                        info = {}
                        return false;
                    }
                } catch (error) {
                    console.log(error);
                    commit("SET_ERROR");

                    throw error;
                }
                commit("SET_SETTINGS", formatAppSettings(settings, type));
                commit("SET_DATA", { ...info, ...settings });
            }
        },
    },
};

export default store;
